const Svg = (
  <svg
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={"100%"}
    height={"100%"}
  >
    <path
      d="M24 24C21.8 24 19.9167 23.2167 18.35 21.65C16.7833 20.0833 16 18.2 16 16C16 13.8 16.7833 11.9167 18.35 10.35C19.9167 8.78333 21.8 8 24 8C26.2 8 28.0833 8.78333 29.65 10.35C31.2167 11.9167 32 13.8 32 16C32 18.2 31.2167 20.0833 29.65 21.65C28.0833 23.2167 26.2 24 24 24ZM8 40V34.4C8 33.2667 8.29167 32.225 8.875 31.275C9.45833 30.325 10.2333 29.6 11.2 29.1C13.2667 28.0667 15.3667 27.2917 17.5 26.775C19.6333 26.2583 21.8 26 24 26C26.2 26 28.3667 26.2583 30.5 26.775C32.6333 27.2917 34.7333 28.0667 36.8 29.1C37.7667 29.6 38.5417 30.325 39.125 31.275C39.7083 32.225 40 33.2667 40 34.4V40H8ZM12 36H36V34.4C36 34.0333 35.9083 33.7 35.725 33.4C35.5417 33.1 35.3 32.8667 35 32.7C33.2 31.8 31.3833 31.125 29.55 30.675C27.7167 30.225 25.8667 30 24 30C22.1333 30 20.2833 30.225 18.45 30.675C16.6167 31.125 14.8 31.8 13 32.7C12.7 32.8667 12.4583 33.1 12.275 33.4C12.0917 33.7 12 34.0333 12 34.4V36ZM24 20C25.1 20 26.0417 19.6083 26.825 18.825C27.6083 18.0417 28 17.1 28 16C28 14.9 27.6083 13.9583 26.825 13.175C26.0417 12.3917 25.1 12 24 12C22.9 12 21.9583 12.3917 21.175 13.175C20.3917 13.9583 20 14.9 20 16C20 17.1 20.3917 18.0417 21.175 18.825C21.9583 19.6083 22.9 20 24 20Z"
      fill="currentColor"
    />
  </svg>
);

export default Svg;
